import { DeviceType } from 'types';

export type GlobalEventsInterface = {
  'globalEvents/setRequestParams': {
    orchestratorHost: string;
    orchestratorBackendHost: string;
    orchestratorHostKz: string;
    useCredentials: boolean;
    apiKey?: string;
  };
  'globalEvents/setRequestID': { requestID: string };
  'globalEvents/isBot': boolean;
  'globalEvents/userAgent': string;
  'globalEvents/pathName': string;
  'globalEvents/logoProUrl': string;
  'globalEvents/setHost': string;
  'globalEvents/deviceType': DeviceType;
};

export const GlobalEvents = {
  setRequestParams: 'globalEvents/setRequestParams',
  setRequestID: 'globalEvents/setRequestID',
  setUserAgent: 'globalEvents/userAgent',
  setIsBot: 'globalEvents/isBot',
  setPathname: 'globalEvents/pathName',
  setLogoProUrl: 'globalEvents/logoProUrl',
  setHost: 'globalEvents/Host',
  setDeviceType: 'globalEvents/deviceType',
} as const;
